'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _connectField = require('uniforms/connectField');

var _connectField2 = _interopRequireDefault(_connectField);

var _joinName = require('uniforms/joinName');

var _joinName2 = _interopRequireDefault(_joinName);

var _AutoField = require('./AutoField');

var _AutoField2 = _interopRequireDefault(_AutoField);

var _ListDelField = require('./ListDelField');

var _ListDelField2 = _interopRequireDefault(_ListDelField);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ListItem = function ListItem(_ref) {
    var removeIcon = _ref.removeIcon,
        props = (0, _objectWithoutProperties3.default)(_ref, ['removeIcon']);
    return _react2.default.createElement(
        'div',
        { className: 'row' },
        _react2.default.createElement(
            'div',
            { className: 'col-xs-1' },
            _react2.default.createElement(_ListDelField2.default, { name: props.name, removeIcon: removeIcon })
        ),
        props.children ? _react.Children.map(props.children, function (child) {
            return _react2.default.cloneElement(child, {
                className: 'col-xs-11',
                name: (0, _joinName2.default)(props.name, child.props.name),
                label: null
            });
        }) : _react2.default.createElement(_AutoField2.default, (0, _extends3.default)({}, props, { className: 'col-xs-11' }))
    );
};

exports.default = (0, _connectField2.default)(ListItem, { includeInChain: false, includeParent: true });


/*****************
 ** WEBPACK FOOTER
 ** ./~/uniforms-bootstrap3/ListItemField.js
 ** module id = ./node_modules/uniforms-bootstrap3/ListItemField.js
 ** module chunks = 0
 **/